import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import BiogiLogo from "../assets/images/ournewlogo.svg";

const Header = () => {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState("/");
  const [isFixed, setIsFixed] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);
  const [subActiveIndex, setSubActiveIndex] = useState(null);

  useEffect(() => {
    setActiveItem(location.pathname);
  }, [location.pathname]);

  const isActive = (path) => (activeItem === path ? "menu-active" : "");

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition >= 20) {
      setIsFixed(true);
    } else {
      setIsFixed(false);
    }
  };

  const [logoScale, setLogoScale] = useState("scale(2.5)");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width > 1200) {
        setLogoScale("scale(5.5)");
      } else {
        setLogoScale("scale(2.5)");
      }
    };

    handleResize(); // Set initial value
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
    setSubActiveIndex(null); // Reset sub menu when main menu is toggled
  };

  const toggleSubAccordion = (index) => {
    setSubActiveIndex(subActiveIndex === index ? null : index);
  };
  return (
    <>
      {/* <!-- ====================================== Main Menu ===================================== --> */}
      <header
        id="top-navbar"
        className={`top-navbar ${isFixed ? "fixed" : ""}`}
      >
        <div className="container">
          <div className="top-navbar_full">
            <div className="back-btn">
              <Link to="/">
                <img
                  src={BiogiLogo}
                  alt="logo"
                  width={80}
                  height={50}
                  style={{
                    transform: logoScale,
                  }}
                />
              </Link>
            </div>
            <div className="hell">
              <ul className="top-navbar-title">
                <li>
                  <NavLink to="/" activeClassName="active">
                    Home
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/about" activeClassName="active">
                    About
                  </NavLink>
                </li>
                <li className="drop-svg dropdown dropdown-7">
                  <NavLink to="/services" activeClassName="active">
                    Services
                  </NavLink>
                </li>
                <li className="drop-svg dropdown dropdown-7">
                  <NavLink to="/portfolio" activeClassName="active">
                    Portfolio
                  </NavLink>
                </li>
                <li className="drop-svg dropdown dropdown-7">
                  <NavLink to="/blog" activeClassName="active">
                    Blog
                  </NavLink>
                </li>
                <li className="drop-svg dropdown dropdown-7">
                  <NavLink to="/career" activeClassName="active">
                    Career
                  </NavLink>
                </li>
                <li>
                  <Link to="/contact">
                    {" "}
                    <NavLink to="/contact" activeClassName="active">
                      Contact
                    </NavLink>
                  </Link>
                </li>
              </ul>

              <div className="outer-menu">
                <input
                  className="checkbox-toggle"
                  type="checkbox"
                  name="checkbox"
                />
                <div className="hamburger">
                  <div></div>
                </div>
                {/* <!-- ====================================== Side Menu ===================================== --> */}
                <div className="menu">
                  <div>
                    <nav>
                      <div className="container">
                        <div className="row sidemenu-main">
                          <div className="col-lg-2">
                            <div className="menu-text">
                              <div className="side-menu-text">
                                <p>MENU</p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-7 side-menu-scroll">
                            <div className="heading2">
                              <Link to="/">Home</Link>
                            </div>
                            <div className="heading2">
                              <Link to="/about">About</Link>
                            </div>
                            <div className="heading2">
                              <Link to="/portfolio">Portfolio</Link>
                            </div>
                            <div className="heading2">
                              <Link to="/services">Services</Link>
                            </div>
                            <div className="heading2">
                              <Link to="/blog">Blog</Link>
                            </div>
                            <div className="heading2">
                              <Link to="/career">Career</Link>
                            </div>
                            <div className="heading2">
                              <Link to="/contact">Contact</Link>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="cont-info">
                              <div className="item">
                                <p className="sub-title-address">Address</p>
                                <p
                                  className="geek-alto"
                                  style={{
                                    textWrap: "nowrap",
                                  }}
                                >
                                  Lazimpat, Kathmandu, Nepal
                                </p>
                              </div>
                              <div className="item">
                                <p className="sub-title-address">Contact Us</p>
                                <p>
                                  <Link to="/mailto:info@marichitechai.com">
                                    info@marichitechai.com
                                  </Link>
                                </p>
                                <p className="underline">
                                  <Link to="tel:+977 9840540455">
                                    +977 9840540455
                                  </Link>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                {/* <!-- ====================================== Side Menu End===================================== --> */}
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* <!-- ====================================== Main Menu End===================================== --> */}
    </>
  );
};
export default Header;
